export default __webpack_public_path__ + "static/1-89789705d4e290e0c30fb7a56bf99905.png";